export default __webpack_public_path__ + "static/niche@mob-17581ff413536ec0cc6a1a3dc72eee57.png";